import React from 'react';
import { FlatList, View, Image } from 'react-native';
import { Button } from '../../../Components/Themed';
import { SocialComponentHelpers } from '../../api';

type ImageListProps = {
    post_id:string,
    images: any[],
    width:number,
    onSelectImage:(image:any) => void
}
const ImageList = ({ width, images, onSelectImage }:ImageListProps) => {
    
    const new_images = SocialComponentHelpers.organizeImages(images, width-2, 350, 2, 125)
    

    const renderImages = (data:{ item:any, index:number }) => {
        return (
            <Button float style={{ padding:0, paddingLeft:data.item.paddingLeft, paddingRight:data.item.paddingRight }} onPress={() => onSelectImage(data.item)}>
                <Image
                    source={{ uri: data.item.url }}
                    style={{ height: data.item.scaledHeight, width: data.item.scaledWidth, borderRadius:8 }}
                    resizeMode='cover'
                />
            </Button>
        )
    }

    const renderImageRows = (data: { item:any, index:number }) => {
        return (
            <View style={{ alignItems:'center', marginBottom:2 }}>
                <FlatList
                    data={data.item}
                    renderItem={renderImages}
                    scrollEnabled={false}
                    horizontal
                />
            </View>
            
        )
    }

    return (
        <View style={{ flexDirection:'row', justifyContent:'center', flexWrap:'wrap' }}>
            <FlatList
                data={new_images}
                keyExtractor={(item, index) => `${item.length}_${index}`}
                renderItem={renderImageRows}
            />
        </View>
    )
}

export default ImageList